<template>
  <div class="login-container">

    <div class="login-name">APP管理中心</div>
    <div class="login-box">
      <h2>用户登录</h2>
      <el-form :model="form"
        :rules="rules"
        ref="loginForm">
        <el-form-item prop="username">
          <el-input v-model="form.username"
            placeholder="请输入用户名"
            prefix-icon="User" />
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="form.password"
            placeholder="请输入密码"
            show-password
            prefix-icon="Lock" />
        </el-form-item>

        <el-form-item prop="captcha">
          <div class="captcha-container">
            <el-input v-model="form.verifyCode"
              placeholder="请输入验证码"
                      @keyup.enter.native="handleLogin"
              style="width: 60%" />
            <div class="captcha-code"
              @click="refreshCaptcha">
              <img :src="captchaSrc">
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
            @click="handleLogin"
            :loading="loading"
            style="width: 100%">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, onUnmounted } from 'vue';
  import { verifyLoginCode, login } from '../Service/loginApi';
  import { getCurrentInstance } from 'vue';

  const md5 = require('js-md5');

  const { proxy } = getCurrentInstance();

  const codeInterval = ref(null)

  // 表单数据
  const form = reactive({
    username: '',
    password: '',
    verifyCode: ''
  });

  // 验证码相关
  const captchaSrc = ref('');
  const loading = ref(false);
  const loginForm = ref(null);



  // 刷新验证码
  const refreshCaptcha = () => {
    verifyLoginCode().then((res) => {
      const imageUrl = URL.createObjectURL(res.data);
      captchaSrc.value = imageUrl;
    });
  };

  // 表单验证规则
  const rules = reactive({
    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    verifyCode: [
      { required: true, message: '请输入验证码', trigger: 'blur' }
      // {
      //   validator: (rule, value, callback) => {
      //     if (value.toLowerCase() !== captchaCode.value.toLowerCase()) {
      //       callback(new Error('验证码不正确'));
      //     } else {
      //       callback();
      //     }
      //   },
      //   trigger: 'blur'
      // }
    ]
  });

  // 登录处理
  const handleLogin = () => {
    loginForm.value.validate((valid) => {
      if (!valid) return;

      loading.value = true;

      login({ username: form.username, password: md5(form.password), verifyCode: form.verifyCode }).then((res) => {
        loading.value = false;
        console.log(res);
        const { status, message } = res.data;
        if (status != 'OK') {
          proxy.$message.error('登录失败:' + message);
        } else {
          proxy.$store.state.user = {userName:form.username}
          proxy.$router.push('/');
        }
      });
    });
  };

  // 初始化生成验证码
  onMounted(() => {
    refreshCaptcha();
    // 30秒自动刷验证码
    codeInterval.value = setInterval(() => {
      refreshCaptcha();
    }, 1000 * 30);
  });
  onUnmounted(() => {
    clearInterval(codeInterval.value);
  })
</script>

<style scoped lang="scss">
  .login-container {
    //display: flex;
    //justify-content: center;
    //align-items: center;
    height: 100vh;
    background: #3E80F2;
  }
  .login-name{
    font-size: 36px;
    text-align: center;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 1px;
    padding-top: 100px;
    margin-bottom: 60px;
    text-shadow: 5px 5px 10px #000000;
  }
  .login-box {
    width: 400px;
    padding: 40px;
    background: white;
    border-radius: 8px;
    margin: 20px auto;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  h2 {
    text-align: center;
    margin-bottom: 30px;
    color: #333;
  }

  .captcha-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .captcha-code {
    width: 35%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    font-family: Arial;
    letter-spacing: 5px;
    font-weight: bold;
    color: #ffffff;
  }
</style>
